// extracted by mini-css-extract-plugin
module.exports = {"image":"ChangeAvatar_image_3jGQ9","isSelected":"ChangeAvatar_isSelected__WSXz"};